module.exports = __webpack_public_path__ + "53a4027b31b05215b8c2ab80308263e1.ttf";